import GoodApp from "../../../../src/events/2022/12/good-app/main";
import * as React from 'react';
export default {
  GoodApp,
  React
};